var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shipment)?_c('div',[_c('shipment-print-kk-v1',{attrs:{"shipment":_vm.shipment}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }